import React, { forwardRef } from "react";
import { MultiSelect } from "primereact/multiselect";
import { classNames } from "primereact/utils";
import { DashlyMultiSelect, type DashlyMultiSelectProps } from "../DashlyMultiSelect/DashlyMultiSelect";

export type DashlyFilterMultiSelectProps = Omit<DashlyMultiSelectProps, "controlVariant" | "showClear"> & {
    showClear?: boolean;
};

/**
 * Filter-bar multiselect — Dashly styling with filter tokens. Use {@link DashlyFilterClearField}
 * or `PageFilterMultiSelect` when a per-field clear button is needed.
 */
const DashlyFilterMultiSelect = forwardRef<MultiSelect, DashlyFilterMultiSelectProps>(
    function DashlyFilterMultiSelect(
        { className, panelClassName, showClear: _showClear = false, controlSize = "md", ...rest },
        ref,
    ) {
        return (
            <DashlyMultiSelect
                ref={ref}
                {...rest}
                controlSize={controlSize}
                controlVariant="filter"
                showClear={false}
                className={classNames(className)}
                panelClassName={classNames("spoofy-filter-multiselect-panel", panelClassName)}
            />
        );
    },
);

DashlyFilterMultiSelect.displayName = "DashlyFilterMultiSelect";

export { DashlyFilterMultiSelect };
